import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';

// import { } from '../../../reducers'
import Settings from './Settings';

export const SettingsContainer = props => (
  <Settings {...props} />
);

const mapStateToProps = () => {
  return { };
}

const mapStateToDispatch = { }

export default compose(
  withRouter,
  connect(mapStateToProps, mapStateToDispatch)
 )(SettingsContainer);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Settings/SettingsContainer.jsx